
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/riviste/[slug]/scopri",
      function () {
        return require("private-next-pages/riviste/[slug]/scopri.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/riviste/[slug]/scopri"])
      });
    }
  